import React from 'react';
import { themeConfig } from '../config/theme';

/**
 * Renders a colored dot indicator for user activity status
 * @param {string} activeStatus - Status from listUsers API: "active", "inactive", or "no record"
 * @returns {JSX.Element} - Colored dot with tooltip
 */
export const renderActivityDot = (activeStatus) => {
  let color;
  let tooltip;

  switch (activeStatus) {
    case 'active':
      color = themeConfig.status.success; // Green
      tooltip = 'User is active (attendance within 60 days)';
      break;
    case 'inactive':
      color = themeConfig.status.error; // Red
      tooltip = 'User is inactive (no attendance for 60+ days)';
      break;
    case 'no record':
      color = themeConfig.text.mutedMedium; // Grey
      tooltip = 'No attendance records found';
      break;
    default:
      color = themeConfig.border.default; // Default grey
      tooltip = 'Unknown status';
  }

  return (
    <span
      style={{
        display: 'inline-block',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: color,
        marginRight: '8px',
        verticalAlign: 'middle'
      }}
      title={tooltip}
    />
  );
};
